import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {IApiDataResponse} from '../../dto/API.dto';
import {ICompany} from '../../dto/Company.dto';
import {apiGet} from '../../axiosConfig';

export type ITnnSponsorProp = {
  id: number;
  name: string;
  category_type: number;
  sponsor: {
    id: number;
    sponsor_name: string;
  };
  campaigns: {
    name: string;
    campaign_types: {
      type: string;
    }[];
  };
  created_at: Date;
};

export const getListAllCompaniesUrl = () => {
  return `v1/company`;
};

const getCompanyList = async (params: IListAllCompaniesQueryParams) => {
  return await apiGet(getListAllCompaniesUrl(), {
    params,
  }).then((response: AxiosResponse<IApiDataResponse<ICompany[]>>) => {
    return response.data.data;
  });
};

export type IListAllCompaniesQueryParams = {
  search: string;
  dma: string[];
  state: string[];
  cmc_product: string[];
  product_type: string[];
  secondary_product_type: string[];
  condition_type: string;
  is_participation_enabled?: boolean;
  module?: 'tnn-campaign' | 'music-section' | 'other';
};

export const useRqListAllCompaniesList = (
  query: IListAllCompaniesQueryParams,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [getListAllCompaniesUrl(), query],
    queryFn: () => getCompanyList(query),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
  });
};

// TNN Company list.
export const getListAllTNNCompaniesUrl = () => {
  return `v1/company/tnn`;
};

export type IListAllTNNCompaniesQueryParams = {
  search: string;
  dma: string[];
  state: string[];
  gt_primary: string[];
  nr_primary: string[];
  gt_secondary: string[];
  nr_secondary: string[];
  tnn?: string;
};

export const tnnCompaniesQueryDefault = {
  search: '',
  dma: [],
  state: [],
  gt_primary: [],
  nr_primary: [],
  gt_secondary: [],
  nr_secondary: [],
};

export type ITnnCompanyProp = {
  id: number;
  name: string;
  type: 'opt-in' | 'opt-out' | 'opt-in-auto';
  sponsor_option_id?: number | null;
  total_attendance?: number | null;
  start_range?: number | null;
  end_range?: number | null;
  form_submitted_by: number;
};
const getCompanyTnnList = async (params: IListAllTNNCompaniesQueryParams) => {
  return await apiGet(getListAllTNNCompaniesUrl(), {
    params,
  }).then((response: AxiosResponse<IApiDataResponse<ITnnCompanyProp[]>>) => {
    return response.data.data;
  });
};

export const useRqListAllTNNCompaniesList = (
  query: IListAllTNNCompaniesQueryParams,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [getListAllTNNCompaniesUrl(), query],
    queryFn: () => getCompanyTnnList(query),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60 * 60,
    enabled: enabled,
  });
};
